import {
    EmailFieldRHF,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IWhenIWorkSetupFieldsPanel {
}
export const WhenIWorkSetupFieldsPanel: FC<
    IWhenIWorkSetupFieldsPanel
> = ({ }) => {

    return (
        <>
            <EmailFieldRHF
                label="Email"
                id="email"
                testId={`toggl-setup-email`}
                labelPosition={LabelPosition.Top}
                labelColumns={4}
                fieldColumns={8}
            // required
            />
            <RHookFormPasswordFieldWithLabel
                id="password"
                testId={`password`}
                label="Password"
                labelPosition={LabelPosition.Top}
            // required
            />
            
        
        </>
    );
};
